<div
  class="dialog component"
  [class.floating]="data.floating"
  cdkDrag
  cdkDragRootElement=".firebird-floating-panel"
  cdkDragBoundary=".cdk-overlay-container"
  [cdkDragDisabled]="!data.floating"
>
  @if (data.title) {
  <div
    class="dialog-header"
    cdkDragHandle
    [ngStyle]="
      data.headerPaddingX !== undefined || data.headerPaddingY !== undefined
        ? {
            padding:
              (data.headerPaddingY ?? 20) +
              'px ' +
              (data.headerPaddingX ?? 30) +
              'px'
          }
        : null
    "
  >
    <div class="title-wrapper">
      @if (data.showPreviousButton) {
      <span mat-dialog-close>
        <mat-icon class="arrow-back">arrow_back_ios</mat-icon>
      </span>
      }
      <div class="dialog-title-group">
        <h3
          class="dialog-title"
          translate
          [ngStyle]="
            data.titleFontSize !== undefined
              ? { 'font-size': data.titleFontSize + 'px' }
              : null
          "
        >
          {{ data.title }}
        </h3>
        @if (data.titleInfoTooltip) {
        <firebird-web-icon
          class="dialog-title-info"
          name="information-circle-filled"
          width="18px"
          height="18px"
          [matTooltip]="data.titleInfoTooltip | translate"
          matTooltipPosition="above"
        ></firebird-web-icon>
        }
      </div>
      @if (data.headerErrorVisible && data.headerErrorMessage) {
      <div class="header-error" role="alert">
        <firebird-web-icon
          class="header-error-icon"
          name="alert-circle"
          width="18px"
          height="18px"
        ></firebird-web-icon>
        <span>{{ data.headerErrorMessage | translate }}</span>
      </div>
      }
    </div>
    <div class="close-wrapper">
      @if (data.showManage) {
      <firebird-web-button
        [type]="'button'"
        [style]="'additional'"
        [name]="'manage'"
        [labelKey]="'Manage' | translate"
        (clickEvent)="onManageClick()"
        ngClass="manage"
      ></firebird-web-button>
      } @if (!data.hideCloseButton) {
      <span class="dialog-close" (click)="close()">
        <span class="icon"></span>
      </span>
      }
    </div>
  </div>
  }

  <div class="dialog-content">
    @if (data.component && isTemplate(data.component)) {
    <ng-container
      [ngTemplateOutlet]="data.component"
      [ngTemplateOutletContext]="data"
    ></ng-container>
    } @if (data.component && !isTemplate(data.component)) {
    <ng-container [ngComponentOutlet]="data.component"></ng-container>
    }
  </div>

  @if (data.floating) {
  <span #resizeHandle class="dialog-resize-handle" aria-hidden="true">
    <firebird-web-icon
      name="resize-handle"
      width="10px"
      height="10px"
    ></firebird-web-icon>
  </span>
  }
</div>
